import store from '../../store';

// functie om alle informatie (dimensions, margins, etc.) over een lichtstraat op te halen met het artikelnummer
function getLichtstraatInfo (code) {
  const allLichtstraten = store.getters.getOptions
  const foundLichtstraat = allLichtstraten.find(l => l.code === code)
  return foundLichtstraat
}

export { getLichtstraatInfo }